import { Button, Dialog, Grid, Stack, Typography, Modal } from "@mui/material"
import { Todo } from './Todo'
import { useContext } from "react"
import { LocalMall, BookOnline, MenuBook } from '@mui/icons-material';
import { ToolContext } from "../../../../core/context/ToolContext";
import { rqx } from "../../../../core/request/API";
import { env } from "../../../../core/Env";
import { getAllData, insertData, updateData } from '../../../../core/global/db/Index'
import { SnakeLoader } from "../../../../core/loader/SnakeLoader";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { hcrmSession } from "../../../../core/validator/Validator";
import CapGueImg from '../../../../assets/images/core/capgue.png'

export const PerIndustry = () => {
    const { personalization_state, tool_state, promo_product_state, setup_training_state } = useContext(ToolContext)
    const { open, selected, onboard, industryLoader } = personalization_state
    const { templates } = promo_product_state
    const { __SESSION, userId } = tool_state 
    const { trainingForm } = setup_training_state
    const history = useHistory()

    const industry_list = [
        {id: 1, name: 'Product', tagline: 'Businesses selling tangible or digital goods.', description: '→ Retail, Wholesale, Manufacturing, E-commerce, Consumer Goods.', icon: <LocalMall sx={{fontSize: 32, color: '#F44336'}} />},
        {id: 2, name: 'Booking & Hospitality', tagline: 'Businesses requiring reservation or scheduling.', description: '→ Hotels, Travel, Tours, Spas, Clinics, Transport, Event Venues.', icon: <BookOnline sx={{fontSize: 32, color: '#2196F3'}}/>},
        // {id: 3, name: 'Professional Services', tagline: 'Businesses offering expert advice or specialized services.', description: '→ Accounting, Audit, Legal, Consulting, Engineering, Architecture, IT Advisory.', icon: <Business sx={{fontSize: 32, color: '#1A237E'}} />},
        {id: 4, name: 'Training & Education', tagline: 'Businesses offering learning or skills development.', description: '→ Schools, Tutorials, E-learning, Coaching, Workshops.', icon: <MenuBook sx={{fontSize: 32, color: '#1976D2'}} />},
    ]

    const handlerIndustry = (v) => {
        selected.set(prev => {
            const exists = prev.some(item => item.id === v.id);
            return exists
                ? prev.filter(item => item.id !== v.id)
                : [...prev, { id: v.id }];
        });

    }
    
    const handlerNext = async() => {
        if (selected.data.length !== 0) {
            if (hcrmSession !== null) {
				industryLoader.set(true)
                const body = {
                    company_id: __SESSION?.data?.uaccess?.[0]?.company_id,
                    user_id: userId?.data,
                    industry: selected.data
                }
                const res = await rqx.post(`<<tool>>/${env()}/industry/createIndustry`, body)
                if (res.message === 'success') {
					industryLoader.set(false)
                    // history.push(`/campaign/promo?type=product&step=template`)
                    open.set(p => ({...p, welcome : false}))
                }
            }else{
                const res = await getAllData('personalization', 'onboarding')
                if (res.length === 0) {
                    await insertData('personalization', 'onboarding', {industry: selected.data})
                }else{
                    await updateData('personalization', 'onboarding', {id: res?.[0]?.id, industry: selected.data})
                }
                if (selected.data.length === 1) {
                    if (selected.data?.[0]?.id === 1) {
                        templates.set({...templates.data, preview: {toggled: true}})
                        history.push(`/campaign/promo?type=product&step=template`)
                    }else if (selected.data?.[0]?.id === 2) {
                        onboard.set(true)
                        history.push(`/campaign/promo/service/customization?step=1`)
                    }else if (selected.data?.[0]?.id === 4) {
                        trainingForm.set({...trainingForm.data, open : true})
                        history.push(`/setup/training`)
                    }
                    open.set(p => ({...p, welcome : false}))
                }else{
                    open.set(p => ({...p, welcome : false, todo : true}))
                }
            }
        }
    }
    
    return (
        <>
            <Dialog open={open.data.welcome} maxWidth="md" fullWidth>
                <Stack direction="column" gap={3} py={3} px={11}>
                    <Stack direction="row" alignItems="center" justifyContent="center">
                        <img src={CapGueImg} alt={CapGueImg} height={128} />
                        <Typography fontSize="1.5rem" fontWeight={600}>
                            Welcome to HRC Business
                        </Typography>
                    </Stack>
                    <Typography textAlign="center" fontSize={22} fontWeight={600}>
                        Please select what your business offers. HRC features will be tailored based on your selection.
                    </Typography>
                    <Grid container rowSpacing="33px" columnSpacing="14px" justifyContent="center">
                        {
                            industry_list.map((v,k) => (
                                <Grid item sm={6} key={k} sx={{cursor: 'pointer'}} onClick={() => handlerIndustry(v)}>
                                    <Stack p={2} gap="14px" minHeight={166} border="1px solid #B6B1B1ED" borderRadius="14px"
                                        sx={{
                                            ':hover': { bgcolor: selected.data.some(item => item.id === v.id) ? "#E0EBD5" : "#F5F5F5" },
                                            bgcolor: selected.data.some(item => item.id === v.id) ? "#E0EBD5" : "#FFFFFF"
                                        }}
                                    >
                                        <Typography fontSize="1.375rem" fontWeight={600}>{v.name}</Typography>    
                                        <Typography fontSize="0.875rem">{v.tagline}</Typography>     
                                        <Typography fontSize="0.875rem" color="#5B6167">
                                            {v.description}    
                                        </Typography>     
                                    </Stack>
                                </Grid>
                            ))
                        }
                    </Grid>
                    <Stack direction="row" justifyContent="flex-end">
                        <Button variant="contained" onClick={handlerNext}
                            sx={{ borderRadius: '10px'}}
                            disabled={selected.data.length === 0}
                        >
                            Submit
                        </Button>
                    </Stack>
                </Stack>
            </Dialog>
            <Todo open={open} industry_list={industry_list} selected={selected} onboard={onboard} />
			<Modal open={industryLoader.data} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<Stack gap='1rem' alignItems="center" p="1rem" sx={{ bgcolor: "#fff", borderRadius: "6px" }}>
					<Typography fontStyle="italic" sx={{ color: "#292C2F" }}>Saving Your Industry...</Typography>
					<SnakeLoader size="12px" bg="#11783C" distance="0.25rem" />
				</Stack>
			</Modal>
        </>
    )
}
